import { resourceOffers, resourceNeeds, skills } from './models';

export const offerOptions = [...skills, ...resourceOffers];
export const needOptions = [...skills, ...resourceNeeds];

/** Preserve the existing matching fields while presenting two simple choice groups. */
export function collaborationFields(offers: string[], needs: string[]) {
  const clean = (values: string[]) => [...new Set(values.map((s) => s.trim()).filter(Boolean))];
  const offer = clean(offers),
    need = clean(needs);
  return {
    skills: offer.filter((s) => !(resourceOffers as readonly string[]).includes(s)),
    brings: offer.filter((s) => (resourceOffers as readonly string[]).includes(s)),
    seeking: need.filter((s) => !(resourceNeeds as readonly string[]).includes(s)),
    wants: need.filter((s) => (resourceNeeds as readonly string[]).includes(s)),
  };
}
